import React from 'react';
import PropTypes from 'prop-types';
import Bet from '../Bet';

const BetList = ({ bets }) => (
  <ul className="settled-bets-list">
    {
      bets.map(betId => (
        <li
          className="settled-bets-list-item"
          key={betId}
        >
          <Bet betId={betId} />
        </li>
      ))
    }
  </ul>
);

BetList.propTypes = {
  bets: PropTypes.object.isRequired
};

export default BetList;
